import React from 'react';
import "./estilodashuser.css";

const Suporte = () => {
  return (
    <div className="container-suporte">
      <h2>Contato e Suporte</h2>

      <div className="suporte-grid">
        {/* Coluna da esquerda: Contatos */}
        <div className="suporte-col">
          <div className="suporte-secao">
            <h3>Informações de Contato</h3>
            <p>
              📱{' '}
              <a
                href="https://wa.me/5542984241307"
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp: (42) 98424-1307
              </a>
            </p>
            <p>
              📧{' '}
              <a href="mailto:contato@quantumtrades.com.br">
                contato@quantumtrades.com.br
              </a>
            </p>
            <p>
              📧{' '}
              <a href="mailto:suporte@quantumtrades.com.br">
                suporte@quantumtrades.com.br
              </a>{' '}
              (Suporte)
            </p>
            <p>
              📺{' '}
              <a
                href="https://www.youtube.com/@QuantumTradesBR"
                target="_blank"
                rel="noreferrer"
              >
                YouTube
              </a>
            </p>
            <p>
              📨{' '}
              <a
                href="https://t.me/QuantumTradesBr"
                target="_blank"
                rel="noreferrer"
              >
                Canal Telegram Aberto
              </a>
            </p>
            <p>
              👥{' '}
              <a
                href="https://t.me/+tdXvf6jsLSZmZjlh"
                target="_blank"
                rel="noreferrer"
              >
                Grupo Telegram VIP para Assinantes
              </a>
            </p>

            <p style={{ marginTop: 16, fontSize: 14 }}>
              Para baixar o robô, templates e arquivos de instalação,
              acesse o menu <strong>Downloads</strong> na lateral esquerda.
            </p>
          </div>
        </div>

        {/* Coluna da direita: Corretora */}
        <div className="suporte-col">
          <div className="suporte-secao">
            <h3>Recomendação de Corretora Forex</h3>
            <p>
              💹 Recomendamos a <strong>Exness</strong> para operações em Forex:
              <br />
              <a
                href="https://one.exnesstrack.org/a/hkga5cflzh"
                target="_blank"
                rel="noreferrer"
                style={{ fontWeight: 'bold' }}
              >
                Clique aqui para abrir sua conta Exness
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suporte;
